import constants from '../constants/constants';
/**
* Calls script based on client action type
* @param { string } action
*/

export const processClientActionType = ( action, methods ) => {
  const {
    clientActionType
  } = action;
  if( action.clientActionType ){
    switch ( clientActionType ){
      case constants.CLIENT_ACTION_TYPES.GLADLY_CHAT_CLICK:
        global.chatWidgetShowHide( true );
        break;
      default:
        return null;
    }
  }
}